<template>
  <a :href="link" :title="title" :target="target">
    <slot name="conteudo"></slot>
  </a>
</template>

<script>
import AsgardStorageBusiness from "@/business/cloudStorage/AsgardStorageBusiness.js";

export default {
  name: "AnexoWrapperDownload",

  props:{
    anexo: {type: Object, default: () => {}},
    title: {type: String, default: ''},
    target: {type: String, default: ''},
    assinado: {type: Boolean, default: false},
    forcarDownload: {type: Boolean, default: true}
  },

  data(){
    return{
      link: '',
    }
  },

  async mounted() {
    let timestamp;
    if (this.$root.isEstadoRS) {
      timestamp = this.$moment().valueOf();
    }
    this.link = AsgardStorageBusiness.getDownloadUrl(this.anexo, this.assinado, timestamp);
  },

}
</script>
